/** Return true if +str+ is null, undefined, or a string consisting of only whitespace. */
export const isBlank = (str) => {
  return str === null || str === undefined || (typeof str === 'string' && str.trim().length === 0);
}
